import axios from 'axios'
import Vue from 'vue'
import store from '@/store/index'

// import { Message } from 'element-ui';

/**
 * 获取一个新的自定义的axios实例 常用接口拦截器
 */

export let ajaxFun = axios.create({
  baseURL:  process.env.API_ROOT,
  timeout: 30000,
  withCredentials: false
})

// 添加request拦截器
ajaxFun.interceptors.request.use(config => {
    return config
}, error => {
    Promise.reject(error)
})
// 添加respone拦截器
ajaxFun.interceptors.response.use(
    response => {
        let res={};
        res.status=response.status
        res.data=response.data;
        //登录过期
        if (response.data.code == -2) {
          store.dispatch('userAuthInvalid');
        }
        // 对接口返回错误进行统一错误提示
        // if(response.data.code != 0){
        //   Message({
        //     message: response.data.msg,
        //     type: 'error'
        //   });
        // }
        return res;
    },
    error => {
        if(error.response && error.response.status == 404){
            router.push('/blank.vue')
        }
        return Promise.reject(error.response)
    }
)


export function get(url, params = {}) {
    params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
    params.userId = localStorage.getItem("userId")?localStorage.getItem("userId"):'';
    return ajaxFun({
        url: url,
        method: 'get',
        headers: {
        },
        params
    })
}


//封装post请求
export function post(url, data = {}) {
    data.userId = localStorage.getItem("userId")?localStorage.getItem("userId"):'';
    //默认配置
    let sendObject={
        url: url,
        method: 'post',
        headers: {
            'Content-Type':'application/json;charset=UTF-8'
        },
        data:data
    };
    sendObject.data=JSON.stringify(data);
    return ajaxFun(sendObject)
}

//不要忘记export
// export {
//     ajaxFun
// }



// WEBPACK FOOTER //
// ./src/utils/request.js